export const addQueryStringParams = (baseUrl, params) => {
  try {
    const url = new URL(baseUrl);

    const search = Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');

    if (url.search.length > 0) {
      url.search += '&';
    }
    url.search += search;

    return url.href;
  } catch (error) {
    return null;
  }
};
